
import { defineComponent, computed } from "vue";
import KTQuickLinksMenu from "@/layout/header/partials/QuickLinksMenu.vue";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";
import Search from "@/layout/header/partials/Search.vue";
import NotificationAlert from "@/layout/header/partials/notification/NotificationAlert.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "topbar",
  components: {
    //KTQuickLinksMenu,
    KTUserMenu,
    NotificationAlert,
    Search,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const currentUser = computed(() => {
      return store.getters.currentUser;
    });

    return {
      currentUser,
    };

  },
});
